// @ts-nocheck
import React from 'react'
import { Tooltip } from 'react-tippy'
import { codeToLocale, getLocaleStr, getTranslatedTextByKey, isRTL } from 'utils/utils'
import styled, { css } from 'styled-components'
import ButtonBase from '@material-ui/core/Button'
import AssetsIcon from './common/AssetsIcon'
import CTAText from 'components/common/CTAText'
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components/macro'
import { ThemeProvider, useTheme } from '@material-ui/core/styles'

// assets
const PHMarkerBase = (props) => <AssetsIcon asset="/icons/ph-marker.svg" {...props} />
const PHLogoBase = (props) => <AssetsIcon asset="/icons/ph-logo.svg" {...props} />

const PhMarker = styled(PHMarkerBase)`
	width: 30px;
	height: 45px;
`

const PHLogo = styled(PHLogoBase)`
	position: absolute;
	width: 18px;
	height: 18px;
	top: 10px;
	right: 10px;
`

const MarkerContainer = styled.div`
	position: relative;
	cursor: pointer;
	transform: translate(${isRTL() ? 15 : -15}px, -43px);
	width: 35px;
`

const MarkerIcon = styled.img`
	width: 30px;
`

const Button = styled(ButtonBase)`
	width: 100%;
	height: 20px;
	background-color: ${({ $themeColor }) => $themeColor};
	color: #fff;
	font-size: 14px;
	font-weight: bold;
`

const DistanceRankText = styled.span`
	position: absolute;
	font-weight: bold;
	top: 10px;
	${isRTL()
		? css`
				right: ${({ is2digits }) => (is2digits ? 7 : 11)}px;
		  `
		: css`
				left: ${({ is2digits }) => (is2digits ? 7 : 11)}px;
		  `};
	font-size: 15px;
`

const MarkerLogo = styled(AssetsIcon)`
	width: 30px;
	height: 45px;
`

const MarkerTitle = styled.h3`
	margin-top: 0;
`

const MarkerTitleContainer = styled.div`
	display: flex;
	justify-content: center;
`

const SelectStoreButton = styled(CTAText)`
	text-transform: uppercase;
`

const Marker = ({ store, formatted, rank, onSelectStore, hasStores, lang }) => {
	const theme = useTheme()

	return (
		<MarkerContainer>
			<Tooltip
				position="top"
				trigger="click"
				theme="light"
				animation="perspective"
				distance={47}
				html={
					/**
					 * The tooltip html component does not have an access to the App root providers,
					 * therefore It needs to be rewrapped.
					 *
					 * The absence of theme providers caused to the following behaviours:
					 *
					 * SelectStoreButton extends CTAText, the last extends TypographyPro.
					 * While rendering of the TypographyPro the theme was not available (because It was not provided in this scope),
					 * therefore the component used a default mui theme instead, which is different from the one that was used previously.
					 * Mui reacts to the change of the theme by creating a new, "updated", style DOM element which is inserted
					 * to the DOM. this new style overwrites the right TypographyPro style that existed before
					 * and results to unexpected style mismatches in the page
					 */

					<ThemeProvider theme={theme}>
						<StyledComponentsThemeProvider theme={theme}>
							<MarkerTitleContainer>
								<MarkerTitle>{getLocaleStr(store.title, codeToLocale[lang] || 'en')}</MarkerTitle>
							</MarkerTitleContainer>
							<div>{formatted}</div>

							<SelectStoreButton onClick={onSelectStore}>
								{getTranslatedTextByKey('eCommerce.storeLocator.select', 'Select')}
							</SelectStoreButton>
						</StyledComponentsThemeProvider>
					</ThemeProvider>
				}
				interactive
				arrow
			>
				{hasStores ? (
					<>
						<MarkerLogo asset="/icons/innerMarkerLogo.svg" />
						<DistanceRankText is2digits={rank > 9}>{rank}</DistanceRankText>
					</>
				) : (
					<MarkerLogo asset="/icons/outerMarkerLogo.svg" testId="store-map-marker" />
				)}
			</Tooltip>
		</MarkerContainer>
	)
}

export default Marker
